interface ProductSchemaProps {
  name: string;
  description: string;
  url: string;
  imageUrl?: string;
  category?: string;
  offers?: {
    price?: string;
    priceCurrency?: string;
    availability?: string;
  };
}

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

export const productJsonLd = (props: ProductSchemaProps) => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  '@id': `${props.url}/#product`,
  name: props.name,
  description: props.description,
  url: props.url,
  ...(props.imageUrl ? { image: props.imageUrl } : {}),
  ...(props.category ? { category: props.category } : {}),
  brand: {
    '@type': 'Brand',
    name: 'Pop Pro Tents',
  },
  manufacturer: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#business`,
    name: 'Pop Pro Tents',
  },
  ...(props.offers ? {
    offers: {
      '@type': 'Offer',
      ...(props.offers.price ? { price: props.offers.price } : {}),
      ...(props.offers.priceCurrency ? { priceCurrency: props.offers.priceCurrency } : {}),
      ...(props.offers.availability ? { availability: `https://schema.org/${props.offers.availability}` } : { availability: 'https://schema.org/InStock' }),
      url: props.url,
    },
  } : {
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      url: props.url,
    },
  }),
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': props.url,
  },
});

export const collectionPageJsonLd = (props: {
  name: string;
  description: string;
  url: string;
  items?: Array<{ name: string; url: string }>;
}) => ({
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  '@id': `${props.url}/#collection`,
  name: props.name,
  description: props.description,
  url: props.url,
  isPartOf: {
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    name: 'Pop Pro Tents',
    url: siteUrl,
  },
  ...(props.items?.length ? {
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: props.items.map((item, idx) => ({
        '@type': 'ListItem',
        position: idx + 1,
        item: {
          '@type': 'Product',
          name: item.name,
          url: item.url,
        },
      })),
    },
  } : {}),
});